import React, { useState, useEffect } from "react";

// @mui components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDAlert from "components/MDAlert";

// Auth Service
import AuthService from "services/auth-service";

function ChangePassword({ user, isDemo }) {
  const passwordRequirements = ["Min 8 characters", "Change it often"];

  const [info, setInfo] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });
  const [errors, setErrors] = useState({
    newPassError: false,
    confirmPassError: false,
  });

  // Bildirimi 5 saniye sonra kapat
  useEffect(() => {
    if (notification.value) {
      const timer = setTimeout(() => {
        setNotification({ value: false, color: "info", message: "" });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  // Input değişim kontrolü
  const changeHandler = (e) => {
    setInfo((prevInfo) => ({
      ...prevInfo,
      [e.target.name]: e.target.value,
    }));
  };

  // Şifre güncelleme submit fonksiyonu
  const submitHandler = async (e) => {
    e.preventDefault(); // Sayfa yenilemeyi engeller
    // Boş alan kontrolü
    if (
        !info.newPassword ||
        !info.confirmPassword
    ) {
      setNotification({
        value: true,
        color: "error",
        message: "All fields are required!",
      });
      return;
    }

    // Şifre eşleşme kontrolü
    if (info.newPassword !== info.confirmPassword) {
      setNotification({
        value: true,
        color: "error",
        message: "Passwords do not match!",
      });
      return;
    }

    // Şifre uzunluk kontrolü
    if (info.newPassword.length < 8) {
      setNotification({
        value: true,
        color: "error",
        message: "Password must be at least 8 characters long!",
      });
      return;
    }

    // API için veri formatı
    const userData = {
      data: {
        attributes: {
          password: info.newPassword,
          password_confirmation: info.confirmPassword,
        },
      },
    };

    // API Çağrısı
    try {
      await AuthService.updateProfile(userData);
      setNotification({
        value: true,
        color: "success",
        message: "Password updated successfully!",
      });
      AuthService.logout(); // Token'ı temizle ve kullanıcıyı çıkış yaptır.
      setInfo({ newPassword: "", confirmPassword: "" });

    } catch (error) {
      console.error("API Hatası:", error);
      setNotification({
        value: true,
        color: "error",
        message: error.response?.data?.message || "An error occurred!",
      });
    }
  };

  // Şifre gereksinimleri gösterimi
  const renderPasswordRequirements = passwordRequirements.map((item, key) => (
      <MDBox key={`requirement-${key}`} component="li" color="text" fontSize="1.25rem">
        <MDTypography variant="button" color="text" fontWeight="regular">
          {item}
        </MDTypography>
      </MDBox>
  ));

  // **Component Return (JSX)**
  return (
      <>
        {/* Bildirim Alanı */}
        {notification.value && (
            <MDAlert color={notification.color}>
              <MDTypography variant="body2" color="white">
                {notification.message}
              </MDTypography>
            </MDAlert>
        )}

        {/* Şifre Güncelleme Kartı */}
        <Card id="change-password">
          <MDBox p={3}>
            <MDTypography variant="h5">Change Password</MDTypography>
          </MDBox>

          {/* **Formun Başlangıcı** */}
          <form onSubmit={submitHandler}>
            <MDBox pb={3} px={3}>
              <Grid container spacing={3}>


                {/* Yeni Şifre */}
                <Grid item xs={12}>
                  <MDInput
                      fullWidth
                      variant="standard"
                      label="New Password"
                      type="password"
                      name="newPassword"
                      value={info.newPassword}
                      onChange={changeHandler}
                      error={errors.newPassError}
                  />
                </Grid>

                {/* Yeni Şifre Onayı */}
                <Grid item xs={12}>
                  <MDInput
                      fullWidth
                      variant="standard"
                      label="Confirm New Password"
                      type="password"
                      name="confirmPassword"
                      value={info.confirmPassword}
                      onChange={changeHandler}
                      error={errors.confirmPassError}
                  />
                </Grid>
              </Grid>

              {/* Şifre Gereksinimleri */}
              <MDBox mt={6} mb={1}>
                <MDTypography variant="h5">Password Requirements</MDTypography>
                <MDBox component="ul" pl={3.25}>
                  {renderPasswordRequirements}
                </MDBox>
              </MDBox>

              {/* Gönder Butonu */}
              <MDBox display="flex" justifyContent="flex-end" mt={3}>
                <MDButton variant="gradient" color="dark" size="small" type="submit">
                  Update Password
                </MDButton>
              </MDBox>
            </MDBox>
          </form>
        </Card>
      </>
  );
}

export default ChangePassword;
